export const IS_PROD = process.env.REACT_APP_ENV === 'production';

export const EMARKETING_BASE_URL = process.env.REACT_APP_EMARKETING_BASE_URL ?? '';

export const DISABLED_STRIPE = process.env.REACT_APP_FEATURE_FLAG_DISABLED_STRIPE === 'true';

export const SEND_CAMPAIGN_MIN_HOUR = 8;
export const SEND_CAMPAIGN_MAX_HOUR = 19;

export const SMS_NOT_AVAILABLE_IN_COUNTRY_ERROR = 'SMS_NOT_AVAILABLE_IN_COUNTRY';

export const SMS_TEXT_MAX_LENGTH = 146;
export const SMS_UNICODE_MAX_LENGTH = 56;
export const MAX_AUTOMATIC_LINK_LENGTH = 28; // '\nhttps://r.lbill.app/ABCDEF'.length;

export const PAYMENT_LINK = IS_PROD
  ? {
      CLIENT_0: 'https://buy.stripe.com/00g8wx7jqbQT7QY28l',
      CLIENT_100: 'https://buy.stripe.com/00g8wx7jqbQT7QY28l',
    }
  : {
      CLIENT_0: 'https://buy.stripe.com/test_bIY8Ac7Q5gMAcpidQR',
      CLIENT_100: 'https://buy.stripe.com/test_bIY8Ac7Q5gMAcpidQR',
    };

export const SentryTags = {
  pages: 'pages',
};

export const SentryContext = {
  handleValidateEmailField: 'handleValidateEmailField',
  handleResetEmailField: 'handleResetEmailField',
  getUberallUsers: 'getUberallUsers',
};

export const DAY_MAP: Record<string, string> = {
  mon: 'basic.days.mon',
  tue: 'basic.days.tue',
  wed: 'basic.days.wed',
  thu: 'basic.days.thu',
  fri: 'basic.days.fri',
  sat: 'basic.days.sat',
  sun: 'basic.days.sun',
};
